// Pure row strings for the Crew directory (mobile overhaul Phase C §9.1).
// The rate column and the booking meta read the same on both widths, and
// both are testable without a DOM (the suite is Node-only).

import { formatDayMonth } from './calendar';
import { formatMoney } from './moneyFormat';

/** "DOP · Refresh Films" — whichever of the two the contact has. */
export function crewContext(crew: { role: string | null; company: string | null }): string | null {
  return [crew.role, crew.company].filter(Boolean).join(' · ') || null;
}

/** The right-hand rate stack: day rate over the half-day line. A contact
    with no rates at all gets a single faint dash instead of "— / — half". */
export function crewRateColumn(crew: {
  day_rate_cents: number | null;
  half_day_rate_cents: number | null;
}): { day: string | null; half: string | null } {
  if (crew.day_rate_cents === null && crew.half_day_rate_cents === null) return { day: null, half: null };
  return {
    day: crew.day_rate_cents === null ? '—' : formatMoney(crew.day_rate_cents),
    half: `/ ${crew.half_day_rate_cents === null ? '—' : formatMoney(crew.half_day_rate_cents)} half`,
  };
}

/** `half_day_dates` is a JSON array of ISO dates; bad JSON counts as none. */
export function crewHalfDayCount(raw: string | null): number {
  if (!raw) return 0;
  try {
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed) ? parsed.length : 0;
  } catch {
    return 0;
  }
}

/** "22–23 Apr", "22 Apr · half day", "22–26 Apr · 2 half days". */
export function crewBookingMeta(booking: {
  start_date: string;
  end_date: string;
  half_day_dates: string | null;
}): string {
  const dates =
    booking.start_date === booking.end_date
      ? formatDayMonth(booking.start_date)
      : `${formatDayMonth(booking.start_date)}–${formatDayMonth(booking.end_date)}`;
  const halves = crewHalfDayCount(booking.half_day_dates);
  if (halves === 0) return dates;
  return `${dates} · ${halves === 1 ? 'half day' : `${halves} half days`}`;
}
